import React from "react";
import DsProgressBar, { clampPercent } from "@components/ds/ProgressBar";
import { tokens } from "../styles";

// Progress bar that color-shifts with capacity, matching the prototype's
// ProgressBar.tsx → getCapacityColor():
//   = 0       → empty gray
//   < 70      → green (low/healthy)
//   71 – 90   → orange (medium)
//   91 – 99   → red    (high)
//   = 100     → blue   (full)

const getColor = (pct) => {
  if (!Number.isFinite(pct) || pct <= 0) return tokens.capacity.empty;
  if (pct >= 100) return tokens.capacity.full;
  if (pct >= 91) return tokens.capacity.high;
  if (pct >= 71) return tokens.capacity.medium;
  return tokens.capacity.low;
};

const ProgressBar = ({ percent = 0, height = 8 }) => {
  const clamped = clampPercent(percent);
  return (
    <DsProgressBar
      percent={clamped}
      color={getColor(clamped)}
      height={height}
    />
  );
};

export default ProgressBar;
